var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHint)?_c('div',{staticClass:"hint"},[_c('ul',_vm._l((_vm.hintText),function(line){return _c('li',[_vm._v("\n      "+_vm._s(line)+"\n    ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }